// extracted by mini-css-extract-plugin
export default {"page":"Projects_page__chZad"};